import React, { useEffect } from 'react'

import useTranslation from '../../../context/hooks/useTranslation'
import isToday from '../../../lib/utils/isToday'
import { useSetShipmentAsReturnMutation } from '../../../redux/services/returns'
import WarnIcon from '../../../vectors/WarnIcon'

export interface ScanResultKeepOnHubReturnProps {
  shipmentId: number
  merchantName: string
  optimizationId: number
  tourTag: string
  day: string
}

export const ScanResultKeepOnHubReturn: React.FC<
  ScanResultKeepOnHubReturnProps
> = ({ shipmentId, merchantName, optimizationId, tourTag, day }) => {
  const { t, trans: Trans } = useTranslation()
  const [setAsReturn] = useSetShipmentAsReturnMutation()

  useEffect(() => {
    setAsReturn({
      optimizationTourId: optimizationId,
      shipmentId,
    })
  }, [optimizationId, setAsReturn, shipmentId])

  return (
    <div className="shadow-elevation-2 flex h-[537px] w-[840px] flex-row overflow-hidden rounded-lg bg-white">
      <div className="bg-light-violet-40 flex w-1/2 flex-col items-center justify-center gap-4">
        <span className="font-heading text-[40px] text-indigo-50">
          {t('RETURNS_SCAN.KEEP_IN_REGION').toUpperCase()}
        </span>
        <span className="bg-gray-34 font-body text-md rounded-md px-5 py-2">
          {t('RETURNS_SCAN.FOR_RETURN_TO_SENDER')}
        </span>
      </div>

      {isToday(day) ? (
        <div className="flex w-1/2 flex-col items-center pt-16 text-indigo-50">
          <div className="bg-yellow-light-fade flex w-[332px] flex-row gap-2 rounded-[4px] px-4 py-2">
            <div>
              <WarnIcon />
            </div>
            <div className="font-heading text-md flex flex-col gap-7">
              <div className="flex flex-col">
                <span className="font-body">
                  {t('RETURNS_SCAN.RETURN_TODAY_TO')}
                </span>
                <span>{merchantName}</span>
              </div>

              <div className="flex flex-col">
                <span className="font-body">
                  {t('RETURNS_SCAN.COLLECTION_OPT_ID')}
                </span>
                <span>{optimizationId}</span>
              </div>

              <div className="flex flex-col">
                <span className="font-body">
                  {t('RETURNS_SCAN.COLLECTION_TOUR_TAG')}
                </span>
                <span>{tourTag}</span>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="flex w-1/2 flex-col items-center pt-16 text-indigo-50">
          <div className="bg-yellow-light-fade flex w-[332px] flex-row gap-2 rounded-[4px] px-4 py-2">
            <div>
              <WarnIcon />
            </div>
            <div className="font-body text-md text-indigo-50">
              <Trans
                t={t}
                i18nKey="RETURNS_SCAN.NO_COLLECTION_TODAY"
                values={{
                  merchantName,
                  day,
                  optimizationId,
                  tourTag,
                }}
                components={{
                  b: <span className="font-heading" />,
                }}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default ScanResultKeepOnHubReturn
